/* FAR 24/09/2026 - Pagina marca divisa per modello di moto: logica di sections/far-brand-models.liquid (vedi commento in testa alla sezione). */
(function () {
function init(root) {
  if (!root || root.getAttribute('data-ready')) return;
  root.setAttribute('data-ready', '1');
  var T = {};
  try { T = JSON.parse(root.querySelector('[data-fbm-i18n]').textContent); } catch (e) {}
  var BRAND = root.getAttribute('data-brand') || '';
  var YEAR = new Date().getFullYear();
  var FOLD_DESK = 10, FOLD_MOB = 4, TILES = 12;
  var mobile = window.matchMedia('(max-width: 749px)');
  var CACHE_KEY = 'farTendina:v1', CACHE_MS = 10 * 60 * 1000;
  var ROOT_URL = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var PH = (root.querySelector('.fbm-ph') || {}).outerHTML || '<svg class="fbm-ph" viewBox="0 0 120 72" fill="none" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="25" cy="50" r="15"/><circle cx="95" cy="50" r="15"/><circle cx="25" cy="50" r="3"/><circle cx="95" cy="50" r="3"/><path d="M25 50 L44 31 H66 L76 38"/><path d="M95 50 L83 20 L91 16"/><path d="M36 30 Q50 17 70 25 L76 31"/><path d="M44 31 L56 47 H76 L83 31"/><path d="M30 38 H44"/></svg>';
  function squash(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function tt(key, map) { var s = T[key] || ''; for (var k in map) s = s.split('{' + k + '}').join(map[k]); return s; }
  function $(sel, el) { return (el || root).querySelector(sel); }
  function $$(sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); }
  var brands = (root.getAttribute('data-brands') || '').split(',').map(squash).filter(Boolean);
  var statusEl = $('[data-fbm-status]'), poolEl = $('[data-fbm-pool]'), idx = $('[data-fbm-index]'), modelsEl = $('[data-fbm-models]');
  root.classList.add('fbm--js');
  statusEl.innerHTML = '<span class="fbm__spin"></span>' + esc(T.loading || '');

  // ---- schede prodotto: pagina 1 stampata dal server, le altre pagine dal template far-brand-pool ----
  var cards = {}, order = {}, seq = 0;
  function takeCards(container) {
    $$('.fbm-card', container).forEach(function (a) {
      var h = a.getAttribute('data-h');
      if (!h || cards[h]) return;
      if (a.ownerDocument !== document) a = document.importNode(a, true);
      if (a.parentNode !== poolEl) poolEl.appendChild(a);
      cards[h] = a; order[h] = seq++;
    });
  }
  takeCards(poolEl);
  function getText(url) { return fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }); }
  function parse(html) { return new DOMParser().parseFromString(html, 'text/html'); }
  function loadPool() {
    var pages = +poolEl.getAttribute('data-pages') || 1, cur = +poolEl.getAttribute('data-page') || 1, reqs = [];
    for (var p = 1; p <= Math.min(pages, 12); p++) {
      if (p === cur) continue;
      reqs.push(getText(root.getAttribute('data-pool-url') + '?view=far-brand-pool&page=' + p).then(function (html) { takeCards(parse(html)); }).catch(function () {}));
    }
    return Promise.all(reqs);
  }
  // prodotti compatibili che non sono nella collezione: scheda singola da templates/product.far-card.liquid
  function loadMissing(handles) {
    handles = handles.slice(0, 60);
    var i = 0;
    function next() {
      if (i >= handles.length) return Promise.resolve();
      var h = handles[i++];
      return getText(ROOT_URL.replace(/\/?$/, '/') + 'products/' + encodeURIComponent(h) + '?view=far-card')
        .then(function (html) { takeCards(parse(html)); }, function () {}).then(next);
    }
    var timeout = new Promise(function (r) { setTimeout(r, 5000); });
    return Promise.race([Promise.all([next(), next(), next(), next()]), timeout]);
  }

  // ---- voci "Moto \u2013 foto modello" oltre le 50 stampate dalla sezione (templates/collection.far-modelli.liquid) ----
  function loadExtra() {
    return fetch(root.getAttribute('data-pool-url') + '?view=far-modelli', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }
  function withWidth(u, w) { return String(u).replace(/([?&]width=)\d+/, function (m, pre) { return pre + w; }); }
  function mediaHTML(x, title) {
    if (!x || !x.i) return PH;
    var srcset = [480, 720, 960, 1200, 1400].map(function (w) { return withWidth(x.i, w) + ' ' + w + 'w'; }).join(', ');
    var credit = '';
    if (x.a || x.l) {
      credit = '<figcaption class="fbm-model__credit" tabindex="0"><span class="fbm-model__credit-i" aria-hidden="true">\u00a9</span><span class="fbm-model__credit-t">' + esc(T.photo || 'Foto') + ': ' +
        (x.f ? '<a href="' + esc(x.f) + '" target="_blank" rel="noopener nofollow">' + esc(x.a || 'Wikimedia Commons') + '</a>' : esc(x.a)) +
        (x.l ? ', ' + (x.lu ? '<a href="' + esc(x.lu) + '" target="_blank" rel="noopener nofollow license">' + esc(x.l) + '</a>' : esc(x.l)) : '') + (x.mod ? ' \u00b7 ' + esc(T.modified || 'modificata') : '') + '</span></figcaption>';
    }
    return '<img src="' + esc(x.i) + '" srcset="' + esc(srcset) + '" sizes="(min-width: 1320px) 680px, (min-width: 750px) 52vw, 100vw" alt="' + esc(title) + '" loading="lazy"' +
      (x.w ? ' width="' + x.w + '" height="' + x.hh + '"' : '') + (x.p ? ' style="object-position:' + esc(x.p) + '"' : '') + '>' + credit;
  }
  function tileImg(x) {
    if (!x || !x.i) return PH;
    return '<img src="' + esc(withWidth(x.i, 360)) + '" alt="" loading="lazy"' + (x.p ? ' style="object-position:' + esc(x.p) + '"' : '') + '>';
  }

  // ---- dati compatibilita: stesso feed e stessa cache della tendina "Ricerca per moto" ----
  function loadFeed() {
    if (typeof window.FAR_FITMENT_FEED === 'function') return window.FAR_FITMENT_FEED();
    try {
      var c = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
      if (c && Date.now() - c.t < CACHE_MS && c.d && c.d.items) return Promise.resolve(c.d);
    } catch (e) {}
    var base = '/collections/all?view=far-tendina';
    function json(u) { return fetch(u, { credentials: 'same-origin' }).then(function (r) { return r.json(); }); }
    return json(base + '&page=1').then(function (first) {
      var reqs = [];
      for (var i = 2; i <= Math.min(+first.pages || 1, 40); i++) reqs.push(json(base + '&page=' + i));
      return Promise.all(reqs).then(function (rest) {
        var items = (first.items || []).slice();
        rest.forEach(function (pg) { items = items.concat(pg.items || []); });
        var d = { items: items };
        try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), d: d })); } catch (e) {}
        return d;
      });
    }).catch(function () { return null; });
  }
  function parseYears(text) {
    var y = String(text || '').replace(/\s+/g, '');
    var m = y.match(/^(\d{4})[-\u2013\u2014\/](\d{4})$/);
    if (m) return +m[1] <= +m[2] ? [+m[1], +m[2]] : [+m[2], +m[1]];
    m = y.match(/^(dal|da|from)?(\d{4})(\+)?$/i);
    if (m) return [+m[2], (m[1] || m[3]) ? YEAR : +m[2]];
    return [0, 0];
  }
  function buildModels(data) {
    var bySku = {}, models = {};
    data.items.forEach(function (it) { if (it[2] && it[1]) bySku[String(it[1]).trim().toUpperCase()] = it[2]; });
    function expand(text, depth) {
      return String(text || '').split(/\r?\n/).map(function (line) {
        var m = line.trim().match(/^(?:come|=)\s+(.+)$/i);
        if (!m) return line;
        var ref = depth < 3 ? bySku[m[1].trim().toUpperCase()] : null;
        return ref ? expand(ref, depth + 1) : '';
      }).join('\n');
    }
    data.items.forEach(function (it) {
      if (!it[2]) return;
      var h = it[0];
      expand(it[2], 0).split(/\r?\n/).forEach(function (line) {
        line = line.trim();
        if (!line || line.charAt(0) === '#') return;
        var p = line.split('|').map(function (s) { return s.trim(); });
        if (p.length < 2 || !p[0] || !p[1]) return;
        var kb = squash(p[0]);
        if (brands.indexOf(kb) < 0) return;
        var k = kb + '|' + squash(p[1]);
        var M = models[k] = models[k] || { k: k, marca: p[0], modello: p[1], h: {}, v: {}, min: 0, max: 0 };
        M.h[h] = 1;
        var kv = squash(p[2] || ''), y = parseYears(p[3]);
        var V = M.v[kv] = M.v[kv] || { k: kv, label: p[2] || '', h: {}, min: 0, max: 0 };
        V.h[h] = 1;
        if (y[0]) {
          V.min = V.min ? Math.min(V.min, y[0]) : y[0]; V.max = Math.max(V.max, y[1]);
          M.min = M.min ? Math.min(M.min, y[0]) : y[0]; M.max = Math.max(M.max, y[1]);
        }
      });
    });
    // doppioni tra marche della stessa pagina: "PIAGGIO | Vespa LX" non si mostra se tutti i suoi prodotti sono gia sotto VESPA
    var byBrand = {};
    Object.keys(models).forEach(function (k) { var b = k.split('|')[0]; byBrand[b] = byBrand[b] || {}; Object.keys(models[k].h).forEach(function (h) { byBrand[b][h] = 1; }); });
    Object.keys(models).forEach(function (k) {
      var p = k.split('|');
      brands.forEach(function (b) {
        if (!models[k] || b === p[0] || p[1].indexOf(b) !== 0 || !byBrand[b]) return;
        if (Object.keys(models[k].h).every(function (h) { return byBrand[b][h]; })) delete models[k];
      });
    });
    return models;
  }
  function yearsText(min, max) {
    if (!min) return '';
    if (max >= YEAR) return (T.since || 'dal') + ' ' + min;
    return min === max ? String(min) : min + '\u2013' + max;
  }
  var PRETTY = { bmw: 'BMW', ktm: 'KTM', mvagusta: 'MV Agusta', cfmoto: 'CFMoto', harleydavidson: 'Harley-Davidson', motoguzzi: 'Moto Guzzi', motomorini: 'Moto Morini', royalenfield: 'Royal Enfield', sym: 'SYM', mbk: 'MBK' };
  function prettyBrand(b) {
    return PRETTY[squash(b)] || String(b).toLowerCase().replace(/(^|[\s-])([a-z])/g, function (m, a, c) { return a + c.toUpperCase(); });
  }
  function slug(s) { return String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }

  // ---- vista: un blocco per modello ----
  var state = { type: '', q: '', group: '*' };
  var views = []; // { el, M, hs, ver, open, tile, built, g }
  function handlesOf(obj) {
    return Object.keys(obj).filter(function (h) { return cards[h]; }).sort(function (a, b) { return order[a] - order[b]; });
  }
  function cardVisible(h) { return !state.type || cards[h].getAttribute('data-t') === state.type; }
  function matchesQ(v) {
    if (!state.q) return true;
    var hay = v.el.getAttribute('data-title') + ' ' + (v.M ? v.M.modello + ' ' + Object.keys(v.M.v).map(function (k) { return v.M.v[k].label; }).join(' ') : '');
    return squash(hay).indexOf(state.q) >= 0;
  }
  function renderView(v) {
    var M = v.M, V = (M && v.ver) ? M.v[v.ver] : null;
    var hs = (V ? handlesOf(V.h) : v.hs).filter(cardVisible);
    var grid = $('[data-fbm-grid]', v.el);
    if (!v.built) {
      grid.innerHTML = '';
      v.hs.forEach(function (h) { grid.appendChild(cards[h].cloneNode(true)); });
      v.built = true;
    }
    var fold = mobile.matches ? FOLD_MOB : FOLD_DESK, shown = 0, allowed = {};
    hs.forEach(function (h) { allowed[h] = 1; });
    $$('.fbm-card', grid).forEach(function (c) {
      var ok = !!allowed[c.getAttribute('data-h')];
      c.classList.toggle('is-hidden', !ok);
      if (ok) { shown++; c.classList.toggle('is-folded', !v.open && shown > fold); } else c.classList.remove('is-folded');
    });
    var more = $('.fbm-more', v.el);
    if (hs.length > fold) {
      if (!more) {
        more = document.createElement('button'); more.type = 'button'; more.className = 'fbm-more';
        grid.parentNode.insertBefore(more, grid.nextSibling);
        more.addEventListener('click', function () {
          v.open = !v.open; renderView(v);
          if (!v.open) v.el.scrollIntoView({ block: 'start' });
        });
      }
      more.textContent = v.open ? T.less : tt('more', { n: hs.length });
      more.classList.remove('is-hidden');
    } else if (more) more.classList.add('is-hidden');
    if (M) {
      var base = v.el.getAttribute('data-title'), suffix = V ? (V.label || yearsText(V.min, V.max)) : '';
      $('[data-fbm-title]', v.el).textContent = base + (suffix ? ' ' + suffix : '');
      var yrs = V ? yearsText(V.min, V.max) : yearsText(M.min, M.max);
      $('[data-fbm-meta]', v.el).innerHTML = '<span><b>' + hs.length + '</b> ' + esc(hs.length === 1 ? T.one : T.compatible) + '</span>' + (yrs ? '<span>' + esc(yrs) + '</span>' : '');
      // 19/10/2026 (Diego): dalla pagina del modello alla guida della Ricerca per moto, con marca, modello e versione gia scelti
      var guida = $('[data-fbm-guida]', v.el);
      if (!guida && T.guide) {
        guida = document.createElement('a'); guida.className = 'fbm-guida'; guida.setAttribute('data-fbm-guida', '');
        var vb = $('[data-fbm-vers]', v.el), info = $('.fbm-model__info', v.el);
        if (vb) vb.parentNode.insertBefore(guida, vb.nextSibling); else if (info) info.appendChild(guida);
      }
      if (guida) {
        var qs = 'marca=' + encodeURIComponent(M.marca) + '&modello=' + encodeURIComponent(M.modello) + (V && V.label ? '&versione=' + encodeURIComponent(V.label) : '') + '&da=marca';
        guida.href = ROOT_URL.replace(/\/?$/, '/') + 'pages/compatibilita-risultati?' + qs;
        guida.innerHTML = esc(tt('guide', { moto: M.modello + (V && V.label ? ' ' + V.label : '') })) + (T.guideSub ? '<small>' + esc(T.guideSub) + '</small>' : '');
      }
    }
    var hide = hs.length === 0 || !matchesQ(v) || !inGroup(v);
    v.el.classList.toggle('is-hidden', hide);
    if (v.tile) {
      v.tile.classList.toggle('is-hidden', hide);
      var n = $('[data-fbm-n]', v.tile);
      if (n) n.textContent = hs.length + ' ' + (T.products || '');
    }
  }
  function versionLabel(V) {
    var y = yearsText(V.min, V.max);
    return (V.label || y || T.yearsNone) + (V.label && y ? ' (' + y + ')' : '');
  }
  function buildVersions(v) {
    var box = $('[data-fbm-vers]', v.el), M = v.M;
    var list = Object.keys(M.v).map(function (k) { return M.v[k]; }).filter(function (V) { return handlesOf(V.h).length; });
    if (list.length < 2) { box.innerHTML = ''; v.ver = ''; return; }
    if (v.ver && !M.v[v.ver]) v.ver = '';
    list.sort(function (a, b) { return (b.min || 0) - (a.min || 0) || (b.max || 0) - (a.max || 0) || a.label.localeCompare(b.label); });
    if (list.length <= 8) {
      box.innerHTML = '<button type="button" class="fbm-chip" data-v="" aria-pressed="' + (v.ver ? 'false' : 'true') + '">' + esc(T.all) + '<small>' + v.hs.length + '</small></button>' +
        list.map(function (V) { return '<button type="button" class="fbm-chip" data-v="' + esc(V.k) + '" aria-pressed="' + (v.ver === V.k ? 'true' : 'false') + '">' + esc(versionLabel(V)) + '<small>' + handlesOf(V.h).length + '</small></button>'; }).join('');
      box.onclick = function (e) {
        var b = e.target.closest('.fbm-chip'); if (!b) return;
        selectVersion(v, b.getAttribute('data-v'));
      };
    } else {
      var id = v.el.id + '-v';
      box.innerHTML = '<label for="' + id + '">' + esc(T.version) + '</label><select id="' + id + '"><option value="">' + esc(T.all) + ' (' + v.hs.length + ')</option>' +
        list.map(function (V) { return '<option value="' + esc(V.k) + '">' + esc(versionLabel(V)) + ' (' + handlesOf(V.h).length + ')</option>'; }).join('') + '</select>';
      box.querySelector('select').value = v.ver;
      box.querySelector('select').onchange = function (e) { selectVersion(v, e.target.value); };
      box.onclick = null;
    }
  }
  function selectVersion(v, kv) {
    v.ver = kv || ''; v.open = false;
    $$('.fbm-chip', $('[data-fbm-vers]', v.el)).forEach(function (x) { x.setAttribute('aria-pressed', x.getAttribute('data-v') === v.ver ? 'true' : 'false'); });
    var sel = $('select', v.el); if (sel) sel.value = v.ver;
    renderView(v);
  }
  // ---- gruppi di modelli (campo "Gruppo" della voce Moto, es. Vespa moderne / Vespa d'epoca) ----
  var groups = [];
  function gk(v) { return v.g == null ? null : squash(v.g); }
  function inGroup(v) { return state.group === '*' || gk(v) === state.group; }
  function nModels(n) { return n + ' ' + ((n === 1 ? T.model : T.models) || ''); }
  function setupGroups() {
    var byK = {}, list = [];
    views.forEach(function (v, i) {
      if (!v.M) return;
      var k = gk(v);
      if (!byK[k]) { byK[k] = { k: k, label: v.g, first: i }; list.push(byK[k]); }
    });
    if (list.length < 2) return;
    var known = Object.keys(T.groups || {});
    function rank(G) { if (!G.k) return -1; var i = known.indexOf(G.k); return i >= 0 ? i : 100 + G.first; }
    list.sort(function (a, b) { return rank(a) - rank(b); });
    // sezioni e riquadri in ordine di gruppo, ogni gruppo con la sua intestazione; "Universali e altri prodotti" resta in fondo
    list.forEach(function (G) {
      var info = (T.groups || {})[G.k] || {};
      G.title = info.t || G.label || BRAND;
      G.head = document.createElement('div');
      G.head.className = 'fbm-group-head'; G.head.id = 'fbm-g-' + (G.k || 'base');
      G.head.innerHTML = '<span class="fbm-group-head__eyebrow" data-fbm-gn></span><h2 class="fbm-group-head__title">' + esc(G.title) + '</h2>' + (info.s ? '<p class="fbm-group-head__sub">' + esc(info.s) + '</p>' : '');
      modelsEl.appendChild(G.head);
      views.forEach(function (v) {
        if (!v.M || gk(v) !== G.k) return;
        modelsEl.appendChild(v.el);
        if (v.tile) idx.appendChild(v.tile);
      });
    });
    views.forEach(function (v) { if (!v.M) modelsEl.appendChild(v.el); });
    groups = list;
    var box = $('[data-fbm-groups]');
    if (!box) return;
    box.setAttribute('aria-label', T.allGroups || '');
    box.innerHTML = '<button type="button" class="fbm-gchip" data-g="*" aria-pressed="true">' + esc(T.allGroups || '') + '<small data-fbm-gc></small></button>' +
      list.map(function (G) { return '<button type="button" class="fbm-gchip" data-g="' + esc(G.k) + '" aria-pressed="false">' + esc(G.title) + '<small data-fbm-gc></small></button>'; }).join('');
    box.onclick = function (e) { var b = e.target.closest('.fbm-gchip'); if (b) selectGroup(b.getAttribute('data-g')); };
  }
  function selectGroup(k) {
    state.group = k == null ? '*' : k;
    $$('.fbm-gchip').forEach(function (x) { x.setAttribute('aria-pressed', x.getAttribute('data-g') === state.group ? 'true' : 'false'); });
    views.forEach(function (v) { v.open = false; });
    renderAll();
  }
  function updateGroups() {
    if (!groups.length) return;
    var all = 0;
    groups.forEach(function (G) {
      var mine = views.filter(function (v) { return v.M && gk(v) === G.k; });
      var n = mine.filter(function (v) { return v.hs.length; }).length, vis = mine.filter(function (v) { return !v.el.classList.contains('is-hidden'); }).length;
      all += n;
      G.head.classList.toggle('is-hidden', !vis);
      $('[data-fbm-gn]', G.head).textContent = nModels(vis);
      var c = $('.fbm-gchip[data-g="' + G.k + '"] [data-fbm-gc]'); if (c) c.textContent = nModels(n);
    });
    var c0 = $('.fbm-gchip[data-g="*"] [data-fbm-gc]'); if (c0) c0.textContent = nModels(all);
  }
  function renderAll() {
    views.forEach(renderView);
    updateGroups();
    var visible = views.filter(function (v) { return !v.el.classList.contains('is-hidden'); });
    statusEl.textContent = (state.q && !visible.length) ? T.noModel : '';
    idx.classList.toggle('is-open', !!state.q || idx.getAttribute('data-open') === '1');
    updateToggle();
  }
  function updateToggle() {
    var tiles = $$('.fbm-tile', idx).filter(function (t) { return !t.classList.contains('is-hidden'); });
    tiles.forEach(function (t, i) { t.classList.toggle('is-extra', i >= TILES); });
    var btn = $('[data-fbm-toggle-models]');
    if (!btn) {
      btn = document.createElement('button'); btn.type = 'button'; btn.className = 'fbm__toggle-models';
      btn.setAttribute('data-fbm-toggle-models', '');
      btn.setAttribute('data-less', T.fewModels || '');
      idx.parentNode.insertBefore(btn, idx.nextSibling);
    }
    if (!btn.getAttribute('data-bound')) {
      btn.setAttribute('data-bound', '1');
      btn.addEventListener('click', function () {
        idx.setAttribute('data-open', idx.getAttribute('data-open') === '1' ? '0' : '1');
        renderAll();
      });
    }
    var open = idx.getAttribute('data-open') === '1';
    btn.textContent = open ? btn.getAttribute('data-less') : (T.allModels || '') + ' (' + tiles.length + ')';
    btn.classList.toggle('is-hidden', !!state.q || tiles.length <= TILES);
  }
  function buildTypes() {
    var box = $('[data-fbm-types]'), count = {};
    Object.keys(cards).forEach(function (h) { var t = cards[h].getAttribute('data-t') || ''; if (t) count[t] = (count[t] || 0) + 1; });
    var types = Object.keys(count).sort(function (a, b) { return count[b] - count[a]; });
    if (types.length < 2) { box.innerHTML = ''; return; }
    box.innerHTML = '<button type="button" class="fbm-chip" data-t="" aria-pressed="true">' + esc(T.allTypes) + '<small>' + Object.keys(cards).length + '</small></button>' +
      types.map(function (t) { return '<button type="button" class="fbm-chip" data-t="' + esc(t) + '" aria-pressed="false">' + esc(t) + '<small>' + count[t] + '</small></button>'; }).join('');
    if (state.type && !count[state.type]) state.type = '';
    $$('.fbm-chip', box).forEach(function (x) { x.setAttribute('aria-pressed', (x.getAttribute('data-t') || '') === state.type ? 'true' : 'false'); });
    box.onclick = function (e) {
      var b = e.target.closest('.fbm-chip'); if (!b) return;
      state.type = b.getAttribute('data-t') || '';
      $$('.fbm-chip', box).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      views.forEach(function (v) { v.open = false; });
      renderAll();
    };
  }
  function fail() {
    root.classList.remove('fbm--js');
    statusEl.textContent = T.failed || '';
    $$('.fbm-model, .fbm-group-head').forEach(function (s) { s.classList.add('is-hidden'); });
    var gb = $('[data-fbm-groups]'); if (gb) gb.innerHTML = '';
    idx.classList.add('is-hidden');
    var btn = $('[data-fbm-toggle-models]'); if (btn) btn.classList.add('is-hidden');
  }

  function start(data, extra) {
    if (!data || !data.items || !data.items.length) return fail();
    var models = buildModels(data);
    if (!Object.keys(models).length) return fail();
    render(models, extra);
    var missing = [];
    Object.keys(models).forEach(function (k) { Object.keys(models[k].h).forEach(function (h) { if (!cards[h] && missing.indexOf(h) < 0) missing.push(h); }); });
    if (missing.length) loadMissing(missing).then(refresh);
  }
  function refresh() {
    views.forEach(function (v) {
      if (!v.M) return;
      var hs = handlesOf(v.M.h);
      if (hs.length === v.hs.length) return;
      v.hs = hs; v.built = false;
      buildVersions(v);
    });
    updateStats();
    buildTypes();
    renderAll();
  }
  function updateStats() {
    var n = views.filter(function (v) { return v.M && v.hs.length; }).length, nProducts = Object.keys(cards).length;
    $('[data-fbm-stats]').textContent = nModels(n) + ' \u00b7 ' + nProducts + ' ' + (T.products || '');
  }
  // 23/10/2026 sera: "Immagine rappresentativa / Moto in foto" nella lingua della pagina (<html lang>), italiano se manca
  function repTxt(){var l=String(document.documentElement.lang||'it').slice(0,2).toLowerCase();return ({en:['Representative image','Bike shown:','Representative image:'],de:['Symbolbild','Abgebildetes Motorrad:','Symbolbild:'],es:['Imagen representativa','Moto en la foto:','Imagen representativa:'],fr:['Image repr\u00e9sentative','Moto sur la photo\u00a0:','Image repr\u00e9sentative\u00a0:']})[l]||['Immagine rappresentativa','Moto in foto:','Immagine rappresentativa:'];}
  function photoCaption(el,x){if(!x||!x.rp)return;var RT=repTxt();var info=el.querySelector('.fbm-model__info'),title=el.querySelector('[data-fbm-title]');if(info&&title&&!info.querySelector('[data-fbm-representative]')){var p=document.createElement('p');p.className='fbm-model__representative';p.setAttribute('data-fbm-representative','');p.appendChild(document.createTextNode(RT[0]));p.appendChild(document.createElement('br'));var small=document.createElement('small');small.textContent=RT[1]+' '+x.rp;p.appendChild(small);title.insertAdjacentElement('afterend',p);}var img=el.querySelector('.fbm-model__media img');if(img)img.alt=RT[2]+' '+x.rp;}
  function render(models, extra) {
    var used = {}, tiles = {}, info = {}, pos = {};
    ((extra && extra.items) || []).forEach(function (x, i) { var k = squash(x.b) + '|' + squash(x.m); info[k] = x; pos[k] = i; });
    var completion=window.FAR_MOTO_PHOTO_COMPLETION||{};Object.keys(completion).forEach(function(k){if(models[k]&&(!info[k]||!info[k].i))info[k]=completion[k];});
    $$('.fbm-tile', idx).forEach(function (t) { var k = (t.getAttribute('data-k') || '').split('|'); tiles[squash(k[0]) + '|' + squash(k[1])] = t; });
    // 1. modelli con foto, nell'ordine deciso in admin
    $$('.fbm-model', modelsEl).forEach(function (el) {
      var k = (el.getAttribute('data-k') || '').split('|'), key = squash(k[0]) + '|' + squash(k[1]), M = models[key];
      if (!M) { el.classList.add('is-hidden'); if (tiles[key]) tiles[key].classList.add('is-hidden'); return; }
      var x=info[key];if(x&&x.i&&!el.querySelector('.fbm-model__media img')){var figure=el.querySelector('.fbm-model__media');if(figure)figure.innerHTML=mediaHTML(x,el.getAttribute('data-title'));var tile=tiles[key],picture=tile&&tile.querySelector('.fbm-tile__img');if(picture)picture.innerHTML=tileImg(x);photoCaption(el,x);}
      used[key] = 1;
      views.push({ el: el, M: M, hs: handlesOf(M.h), ver: '', open: false, tile: tiles[key], g: el.getAttribute('data-group') || '' });
    });
    // 2. modelli in tendina senza voce con foto: compaiono lo stesso, in fondo, per numero di prodotti
    Object.keys(models).filter(function (k) { return !used[k]; })
      .sort(function (a, b) {
        var pa = k2pos(a), pb = k2pos(b);
        return pa - pb || Object.keys(models[b].h).length - Object.keys(models[a].h).length;
      })
      .forEach(function (k) {
        var M = models[k], x = info[k], title = (x && x.t) || (prettyBrand(M.marca) + ' ' + M.modello);
        var id = 'fbm-' + ((x && x.h) || slug(M.marca + ' ' + M.modello));
        var short = title.indexOf(BRAND + ' ') === 0 ? title.slice(BRAND.length + 1) : title, g = (x && x.g) || '';
        var el = document.createElement('section');
        el.className = 'fbm-model'; el.id = id; el.setAttribute('data-title', title); el.setAttribute('data-group', g);
        el.innerHTML = '<div class="fbm-model__top"><figure class="fbm-model__media">' + mediaHTML(x, title) + '</figure><div class="fbm-model__info"><span class="fbm-model__eyebrow">' + esc(BRAND) + '</span><h2 class="fbm-model__title" data-fbm-title>' + esc(title) + '</h2><span class="fbm-model__bar"></span><p class="fbm-model__meta" data-fbm-meta></p><div class="fbm-model__vers" data-fbm-vers></div></div></div><div class="fbm-grid" data-fbm-grid></div>';
        photoCaption(el,x);
        modelsEl.appendChild(el);
        var tile = document.createElement('a');
        tile.className = 'fbm-tile'; tile.href = '#' + id;
        tile.innerHTML = '<span class="fbm-tile__img">' + tileImg(x) + '</span><span class="fbm-tile__name">' + esc(short) + '</span><span class="fbm-tile__n" data-fbm-n></span>';
        idx.appendChild(tile);
        views.push({ el: el, M: M, hs: handlesOf(M.h), ver: '', open: false, tile: tile, g: g });
      });
    function k2pos(k) { return pos.hasOwnProperty(k) ? pos[k] : 100000; }
    // 3. prodotti della collezione senza righe per queste marche
    var assigned = {};
    Object.keys(models).forEach(function (k) { Object.keys(models[k].h).forEach(function (h) { assigned[h] = 1; }); });
    var rest = Object.keys(cards).filter(function (h) { return !assigned[h]; }).sort(function (a, b) { return order[a] - order[b]; });
    if (rest.length) {
      var other = tt('other', { b: BRAND }), el = document.createElement('section');
      el.className = 'fbm-model fbm-model--other'; el.id = 'fbm-altri'; el.setAttribute('data-title', other);
      el.innerHTML = '<div class="fbm-model__info"><span class="fbm-model__eyebrow">' + esc(BRAND) + '</span><h2 class="fbm-model__title">' + esc(other) + '</h2><span class="fbm-model__bar"></span><p class="fbm-model__meta">' + esc(tt('otherSub', { b: BRAND })) + '</p></div><div class="fbm-grid" data-fbm-grid></div>';
      modelsEl.appendChild(el);
      views.push({ el: el, M: null, hs: rest, ver: '', open: false, g: null });
    }
    setupGroups();
    views.forEach(function (v) { if (v.M) buildVersions(v); });
    updateStats();
    buildTypes();
    statusEl.textContent = '';
    renderAll();
    // link diretto: ?modello=Panigale&versione=V4, ?gruppo=epoca oppure #fbm-<handle>
    var params = new URLSearchParams(location.search), qm = squash(params.get('modello')), qv = squash(params.get('versione')), qg = squash(params.get('gruppo'));
    var target = null;
    if (qg && groups.length) {
      var G = groups.filter(function (x) { return x.k === qg || squash(x.title) === qg; })[0] ||
        groups.filter(function (x) { return x.k && (x.k.indexOf(qg) >= 0 || squash(x.title).indexOf(qg) >= 0); })[0];
      if (G) selectGroup(G.k);
    }
    if (qm) {
      target = views.filter(function (v) { return v.M && squash(v.M.modello) === qm; })[0] || null;
      if (target && !inGroup(target)) selectGroup('*');
      if (target && qv && target.M.v[qv]) selectVersion(target, qv);
    } else if (location.hash && location.hash.indexOf('#fbm-') === 0) {
      target = views.filter(function (v) { return '#' + v.el.id === location.hash; })[0] || null;
      groups.forEach(function (G) { if (!target && '#' + G.head.id === location.hash) target = { el: G.head }; });
    }
    if (target) setTimeout(function () { target.el.scrollIntoView({ block: 'start' }); }, 80);
  }

  var q = $('[data-fbm-q]'), timer;
  q.addEventListener('input', function () {
    clearTimeout(timer);
    // la ricerca vale su tutta la pagina: se era scelto un gruppo si torna a "Tutti i modelli"
    timer = setTimeout(function () { state.q = squash(q.value); if (state.q && state.group !== '*') selectGroup('*'); else renderAll(); }, 120);
  });
  if (mobile.addEventListener) mobile.addEventListener('change', function () { views.forEach(renderView); });

  Promise.all([loadFeed(), loadPool(), loadExtra()]).then(function (res) { return start(res[0], res[2]); }).catch(fail);
}
function boot() { Array.prototype.forEach.call(document.querySelectorAll('.fbm[data-brands]'), init); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
